import { authWebUsOverlay } from "@ferrivia/auth-web";
import type { Resource } from "@ferrivia/i18n";
import fi from "./locales/fi.json";
import en from "./locales/en.json";

export const clinicResources: Resource = {
  fi: { clinic: fi },
  en: { clinic: en },
};

export const usOverlayResources: Resource = authWebUsOverlay;
